import 'jquery-ui';
import 'jquery-ajax-unobtrusive';

import(/* webpackPrefetch: true */ './global/BlogListLoader.js');
import(/* webpackPrefetch: true */ './global/gdpr.js');
import(/* webpackPrefetch: true */ './global/jquery.polyfills.js');
import(/* webpackPrefetch: true */ './global/OpenInNewWindow.js');
import(/* webpackPrefetch: true */ './global/ssm.js');
import(/* webpackPrefetch: true */ './global/usercentrics.js');
import(/* webpackPrefetch: true */ './global/site.js');